import BillAccountTransactionIcon from '@material-ui/icons/ViewList';

import BillAccountTransactionList from './BillAccountTransactionList';

export default {
  list: BillAccountTransactionList,
  icon: BillAccountTransactionIcon,
};
